import customizeTableColumnsComponent from './customize-table-columns.component';

const customizeTableColumnsModule = angular.module('customizeTableColumns', [
])
  .component('customizeTableColumns', customizeTableColumnsComponent)
  .name;

export default customizeTableColumnsModule;
